"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloudFrontPrivatePolicyUrl = exports.cloudFrontUrl = void 0;
exports.cloudFrontUrl = 'https://d3axmgt2k0ra9d.cloudfront.net/';
exports.cloudFrontPrivatePolicyUrl = exports.cloudFrontUrl + "FlyWayPolitykaPrywatnosci.pdf";
